export default "__VITE_ASSET__BUakUCK5__"